import axios from "axios";
import store from "@/store";

// import flight from "./flight";
// import auth from "./auth";

const origin = window.origin + "/api";

export const api = axios.create({
  baseURL: origin,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    // use global loader to dont check any req every time
    store.commit("setLoading", { isLoading: true, message: "Загрузка..." });
    return config;
  },
  (error) => {
    store.commit("setLoading", { isLoading: false });
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    store.commit("setLoading", { isLoading: false });
    return response;
  },
  (error) => {
    store.commit("setLoading", { isLoading: false });

    if (error.response) {
      const message = error.response.data.message || "An error occurred";

      store.dispatch("showAlert", {
        type: "error",
        message,
      });
    }

    return Promise.reject(error);
  }
);

export const handleError = (error) => {
  if (error.response) {
    const message = error.response.data?.message || "Request failed";

    throw new Error(message);
  } else if (error.request) {
    throw new Error("Network error - no response from server");
  } else {
    throw new Error("Request setup error");
  }
};

// export default modules = {
//     flight, auth
// }
